import * as React from 'react';
import {loadModules} from 'esri-loader';

export default class KMLLayer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            KMLlayer: null
        };
    }

    componentDidMount() {
        loadModules([
            'esri/layers/KMLLayer',
            'esri/geometry/SpatialReference',
        ]).then(([KMLLayer, SpatialReference]) => {
            const spatialReference = new SpatialReference(4326);

            let KMLLayerProps = {
                url: this.props.url,
                title: this.props.title,
                visible: !!this.props.visible,
                spatialReference: spatialReference
            };

            if(this.props.id){
                KMLLayerProps['id'] = this.props.id
            }

            const KMLlayer = new KMLLayer(KMLLayerProps);
            this.setState({KMLlayer});
            this.props.map.add(KMLlayer);

        }).catch((err) => console.error(err));
    }

    componentWillUnmount() {
        this.props.map.remove(this.state.KMLlayer);
    }

    render() {
        return null;
    }
}
KMLLayer.defaultProps = {
    opacity: 0.75
};
